import { InvalidUrlError } from '@execonline-inc/url';
import { HttpError } from 'ajaxian';
import { Maybe, nothing } from 'maybeasy';
import { SetStateAction } from 'react';
import { AppyError } from '../../../../../../../../../../Appy';
import { Resource } from '../../../../../../../../../../Resource/Types';
import { TPlainTextKey } from '../../../../../../../../../../Translations';
import { ToString } from '../../../../../../../../../Options/Types';

export type FilterError = HttpError | InvalidUrlError | AppyError;

export type FilterValue = string;

export interface ExtendedGroupOption<T extends ToString> {
  value: T;
  label: string;
  participantCount: number;
}

export type FilterOption = ExtendedGroupOption<string>;
export type FilterOptions = FilterOption[];
export type FilterOptionsResource = Resource<FilterOptions>;

interface Ready {
  kind: 'ready';
}

export type NewState = SetStateAction<State>;

export interface Filtering {
  kind: 'filtering';
  filterBy: FilterValue;
}

interface Filtered {
  kind: 'filtered';
  filterBy: FilterValue;
  optionsResource: FilterOptionsResource;
  selectedValue: Maybe<FilterOption>;
}

export interface OptionSelected {
  kind: 'option-selected';
  optionsResource: FilterOptionsResource;
  selectedValue: FilterOption;
}

export interface Error {
  kind: 'error';
  message: TPlainTextKey;
}

export type State = Success | Error;

export type Success = Ready | Filtering | Filtered | OptionSelected;

export const ready = (): Ready => ({
  kind: 'ready',
});

export const filtering = (filterBy: FilterValue): Filtering => ({
  kind: 'filtering',
  filterBy,
});

export const filtered = (optionsResource: FilterOptionsResource, filterBy: string): Filtered => ({
  kind: 'filtered',
  optionsResource,
  filterBy: filterBy,
  selectedValue: nothing(),
});

export const optionSelected = (
  selectedValue: FilterOption,
  optionsResource: FilterOptionsResource,
): OptionSelected => ({
  kind: 'option-selected',
  optionsResource,
  selectedValue,
});

export const error = (message: TPlainTextKey): Error => ({
  kind: 'error',
  message,
});
